import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './slices/cartSlice';
import orderReducer from './slices/orderSlice';
import shippingReducer from './slices/shippingSlice';
import trackingReducer from './slices/trackingSlice';
import supportMessageReducer from './slices/supportMessageSlice';
import userReducer from './slices/userSlice';
import productListReducer from './slices/productSlice';
import userConfirmationReducer from './slices/userConfirmationSlice';
import userPasswordReducer from './slices/userPasswordSlice';
import categoriesReducer from './slices/categorySlice';
import serviceClientReducer from './slices/serviceClientSlice';
import { productQuickImportReducer } from './reducers/productReducers';
import {
  clearHomeRestoreState,
  getAuthSignature,
  getHomeAuthSignature,
  isHardReloadNavigation,
  setHomeAuthSignature,
} from './utils/homeRestoreState';


// Load data from localStorage
const cartItemsFromStorage = localStorage.getItem('cartItems')
  ? JSON.parse(localStorage.getItem('cartItems'))
  : [];

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

// Ensure Home restore state is reset on hard reload or auth changes BEFORE any components mount.
try {
  const currentSig = getAuthSignature(userInfoFromStorage);
  const prevSig = getHomeAuthSignature();
  if (isHardReloadNavigation() || (prevSig && prevSig !== currentSig)) {
    clearHomeRestoreState();
  }
  setHomeAuthSignature(currentSig);
} catch (_) {}

const shippingAddressFromStorage = localStorage.getItem('shippingAddress')
  ? JSON.parse(localStorage.getItem('shippingAddress'))
  : {};

const selectedRateFromStorage = localStorage.getItem('selectedRate')
  ? JSON.parse(localStorage.getItem('selectedRate'))
  : {};

// Preloaded state for cart and user
const preloadedState = {
  cart: {
    cartItems: cartItemsFromStorage,
    shippingAddress: shippingAddressFromStorage,
    selectedRate: selectedRateFromStorage,
  },
  user: {
    userInfo: userInfoFromStorage,
  },
};

// Configure the store with slices
const store = configureStore({
  reducer: {
    productList: productListReducer,
    productQuickImport: productQuickImportReducer,
    cart: cartReducer,
    order: orderReducer,
    shipping: shippingReducer,
    tracking: trackingReducer,
    supportMessage: supportMessageReducer,
    user: userReducer,
    userConfirmation: userConfirmationReducer,
    userPassword: userPasswordReducer,
  categories: categoriesReducer,
  serviceClient: serviceClientReducer,
  },
  preloadedState,
  devTools: process.env.NODE_ENV !== 'production',
});
export default store;